import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { OptionElement } from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';
import { SelectNative } from 'src/domains/layouts/shared/formComponents/Select/SelectNative';
import { SelectNativeStateNew } from 'src/domains/layouts/shared/formComponents/Select/SelectNativeStateNew.state';

interface SelectOptionsType {
    key: string;
    name: string;
}

interface SelectPropsType {
    className?: string;
    version?: 'primary' | 'secondary';
    label?: string;
    defaultText?: string;
    stateValue: FormInputState<string, string> | FormInputState<string, number | null> | string;
    selectOptions: Array<SelectOptionsType>;
    onChangeCB?: (value: string) => void;
    onClick?: () => void;
    dataTest?: string;
    loading?: boolean;
}

export const Select = observer(
    'Select',
    ({
        className,
        version,
        label,
        defaultText,
        stateValue,
        selectOptions,
        onChangeCB,
        onClick,
        dataTest,
        loading = false,
    }: SelectPropsType) => {
        const [state] = useState(() => new SelectNativeStateNew(stateValue, onChangeCB));

        const value = typeof stateValue === 'string' ? stateValue : stateValue.value;

        return (
            <>
                {label === undefined ? null : <InputLabel>{label}</InputLabel>}

                <SelectNative
                    className={className}
                    version={version}
                    dataTest={dataTest}
                    onChange={state.onChange}
                    onClick={onClick}
                    value={value}
                    error={state.errorMessage}
                >
                    {loading && <OptionElement value=''>Loading...</OptionElement>}
                    {defaultText === undefined ? null : (
                        <OptionElement
                            defaultValue={defaultText}
                            value=''
                            disabled
                            hidden
                        >
                            {defaultText}
                        </OptionElement>
                    )}
                    {loading === false && selectOptions.length > 0 && (
                        <>
                            {selectOptions.map(({ key, name }: SelectOptionsType) => (
                                <OptionElement
                                    key={key}
                                    value={key}
                                >
                                    {name}
                                </OptionElement>
                            ))}
                        </>
                    )}
                    {loading === false && selectOptions.length === 0 && (
                        <OptionElement value=''>There are no options available</OptionElement>
                    )}
                </SelectNative>
            </>
        );
    }
);
